import { formatPercent, formatShares, currency } from '../utils';
import {
  COLLEGE_FUND_NOTE_PHONE_NUMBERS,
  TOLL_FREE_NUMBER,
  UNIT,
} from '../../settings/settings';
import Phone from '../../components/Shared/Phone/Phone';
import React from 'react';
import { getHasCollegeOnly } from '../../redux/modules/productTypes/productType.selectors';
import { isProductType529 } from '../funds/funds-utility';
import { extractValueFromLabelValuePairArray } from '../utils';

export const formattedAmountAutomatic = (fund) => {
  const { currentYearAmountUnit, currentYearAmount } = fund;

  switch (currentYearAmountUnit?.toUpperCase()) {
    case UNIT.SHARES:
      return formatShares(currentYearAmount, 'share');
    case UNIT.PERCENT:
      return formatPercent(currentYearAmount);
    default:
      return currency(currentYearAmount);
  }
};

export const cantEditText = (
  <div className="automatic-action-options-toolTip">
    {' '}
    Please call us at <Phone phoneNumber={TOLL_FREE_NUMBER} /> to edit this{' '}
    {getHasCollegeOnly ? 'contribution' : 'transaction'}.
  </div>
);

export const automaticTipText = (fund) => {
  return (
    <div className="automatic-action-options-toolTip">
      {' '}
      Updates may take up to three business days to process. Please call{' '}
      <Phone
        phoneNumber={
          isProductType529(fund.productType)
            ? COLLEGE_FUND_NOTE_PHONE_NUMBERS[fund.productType]
            : TOLL_FREE_NUMBER
        }
      />{' '}
      to make changes.{' '}
    </div>
  );
};

/**
 * Trigger to display start date tooltip
 *
 * @param openModal
 * @param modalName
 */
export function showStartDateToolTip(openModal, modalName) {
  openModal(modalName);
}

/**
 * Returns systematic sell fund selections
 *
 * @param selectedSellFunds
 * @return {object}
 */
export function getSystematicSelections(selectedSellFunds) {
  return selectedSellFunds.map((fund) => {
    const { agreementID } = fund;
    const [transferDays, transferMonths] = [
      fund.selectedDays,
      fund.selectedMonths,
    ].map(extractValueFromLabelValuePairArray);
    return {
      agreementID,
      days: transferDays,
      months: transferMonths,
    };
  });
}
